import { render, staticRenderFns } from "./AssetTypePicker.vue?vue&type=template&id=6ab15b80&"
import script from "./AssetTypePicker.vue?vue&type=script&lang=js&"
export * from "./AssetTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./AssetTypePicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports